import { LuMail, LuPhone, LuMapPin, LuArrowUpRight } from "react-icons/lu"
import { useNavigate } from "react-router-dom"
import "./Footer.css"

function Footer() {

  const navigate = useNavigate()

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const goHome = () => {
    navigate("/home")
    scrollTop()
  }

  const goAbout = () => {
    navigate("/about")
    scrollTop()
  }

  const goServices = () => {
    navigate("/services")
    scrollTop()
  }

  const goDatabase = () => {
    navigate("/database")
    scrollTop()
  }

  const goContact = () => {
    navigate("/contact")
    scrollTop()
  }

  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-left">
          <img 
            src="/assets/logo2.png" 
            alt="logo" 
            className="footer-logo"
            onClick={goHome}
          />

          <p className="footer-description">
            We build structured career roadmaps using verified industry
            research and trusted learning sources. Clear direction.
            Real growth. Genuine guidance.
          </p>
        </div>

        <div className="footer-links">
          <h4>Platform</h4>
          <button onClick={goHome}>Home</button>
          <button onClick={goServices}>Services</button>
          <button onClick={goAbout}>About</button>
        </div>

        <div className="footer-links">
          <h4>Resources</h4>
          <button onClick={goDatabase}>Database</button>
          <button onClick={goContact}>Contact</button>
        </div>

        <div className="footer-contact">
          <h4>Contact</h4>

          <div className="footer-contact-item">
            <LuMail /> sanketpadhyal3@gmail.com
          </div>

          <div className="footer-contact-item">
            <LuPhone /> +91 9284024617
          </div>

          <div className="footer-contact-item">
            <LuMapPin /> India
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2026 SLUZ. All rights reserved.</p>

        <button className="back-to-top" onClick={scrollTop}>
          Back to Top <LuArrowUpRight />
        </button>
      </div>
    </footer>
  )
}

export default Footer